import React from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2';
import { useUserMetadata } from '../context/UserMetadataContext';
import TrustDegradationDashboard from '../components/Profile360/components/TrustDegradationDashboard';
import { PageHeader, StatCard } from '../components/shared';
import GppBadIcon from '@mui/icons-material/GppBad';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import BoltIcon from '@mui/icons-material/Bolt';
import WarningIcon from '@mui/icons-material/Warning';
import SearchIcon from '@mui/icons-material/Search';

const TrustIntelligencePage = ({ section = 'scores' }) => {
  const { userMetadata } = useUserMetadata();
  const tenantName = userMetadata?.company || 'trustx';

  return (
    <Box>
      <PageHeader
        title="Trust Intelligence"
        description="Insider Risk & Trust Degradation Detection — Early warning for trust erosion and behavioral anomalies"
        pillarId="trust"
      />

      <Grid2 container spacing={2} sx={{ mb: 3 }}>
        <Grid2 xs={12} sm={6} md={3}>
          <StatCard label="Critical Trust" value="—" color="error.main" icon={GppBadIcon} />
        </Grid2>
        <Grid2 xs={12} sm={6} md={3}>
          <StatCard label="Degrading" value="—" color="warning.main" icon={TrendingDownIcon} />
        </Grid2>
        <Grid2 xs={12} sm={6} md={3}>
          <StatCard label="High Velocity" value="—" color="info.main" icon={BoltIcon} />
        </Grid2>
        <Grid2 xs={12} sm={6} md={3}>
          <StatCard label="Suspicious Activity" value="—" color="success.main" icon={WarningIcon} />
        </Grid2>
      </Grid2>

      <Card sx={{ mb: 3, bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(212, 146, 94, 0.08)' : 'rgba(212, 146, 94, 0.05)' }}>
        <CardContent sx={{ py: 2, display: 'flex', alignItems: 'center', gap: 2 }}>
          <SearchIcon sx={{ color: 'warning.main' }} />
          <Typography variant="body2">
            <strong>Trust Intelligence Mission:</strong> Detect trust erosion early by correlating behavioral baselines with access patterns.
            Predict failures before incidents occur.
          </Typography>
        </CardContent>
      </Card>

      <TrustDegradationDashboard tenantName={tenantName} />
    </Box>
  );
};

export default TrustIntelligencePage;
